import { differenceInDays } from "date-fns";
import { useEffect } from "react";

import { MIN_DAYS_TO_NOTIFY } from "@seneca/parents-service-consts";

import { useTeacherContext } from "features/teachers/routes/teacher/routes/homepage/context";

const INVITE_ALL_PARENTS_MODAL_STORAGE_KEY = "invite-all-parents-modal-date";

export default function useCanInviteAllParents() {
  const context = useTeacherContext();
  const { state, setState } = context;

  useEffect(() => {
    const lastInviteDate = window.localStorage.getItem(
      INVITE_ALL_PARENTS_MODAL_STORAGE_KEY
    );
    if (lastInviteDate && !canSendTeacherParentEmail(lastInviteDate)) {
      setState({ canInviteAllParents: false });
    }
  }, [setState]);

  function updateLastInviteSent() {
    window.localStorage.setItem(
      INVITE_ALL_PARENTS_MODAL_STORAGE_KEY,
      new Date().toDateString()
    );
    setState({ ...state, canInviteAllParents: false });
  }

  return {
    canInviteAllParents: state.canInviteAllParents,
    updateLastInviteSent
  };
}

function canSendTeacherParentEmail(dateLastSent: string) {
  const today = new Date();
  const lastSent = new Date(dateLastSent);
  const dayDifference = differenceInDays(today, lastSent);
  return dayDifference >= MIN_DAYS_TO_NOTIFY;
}
